import { createContext } from 'react'

import { AuthStateContextType } from './AuthContext.types'

export const AuthStateContext = createContext<AuthStateContextType | undefined>(undefined)
